import { render, staticRenderFns } from "./BrandedFooter.vue?vue&type=template&id=13ad38ec&scoped=true&lang=pug&"
import script from "./BrandedFooter.vue?vue&type=script&lang=ts&"
export * from "./BrandedFooter.vue?vue&type=script&lang=ts&"
import style0 from "./BrandedFooter.vue?vue&type=style&index=0&id=13ad38ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad38ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VFooter,VLayout})
